import { render, staticRenderFns } from "./TerminalsList.vue?vue&type=template&id=5a54fb63"
import script from "./TerminalsList.vue?vue&type=script&lang=js"
export * from "./TerminalsList.vue?vue&type=script&lang=js"
import style0 from "./TerminalsList.vue?vue&type=style&index=0&id=5a54fb63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports